export default __webpack_public_path__ + "93ad70e8dffa58f12f8c51d49ab43904.svg";